import { createAsyncThunk } from '@reduxjs/toolkit'
import type { AppDispatch, RootState } from '@/redux/store'
import WebSocketManager from '@/services/websocketManager'
import { resetMemberSession } from '../slices/charterPrepMonitorSlice'

const wsManager = WebSocketManager.getInstance()

export const connectCharterPrepMonitorWS = createAsyncThunk<
  void,
  { jwtToken: string; roomId: string; inviteCode: string; teamId: string; memberId: string },
  { dispatch: AppDispatch; state: RootState }
>(
  'ws/connectCharterPrepMonitor',
  async ({ jwtToken, roomId, inviteCode, teamId, memberId }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(resetMemberSession(memberId))
      return await wsManager.connectToCharterPrepMonitor(
        jwtToken,
        roomId,
        inviteCode,
        teamId,
        memberId
      )
    } catch (error) {
      return rejectWithValue(
        (error as Error).message || 'Failed to connect to prep monitor WebSocket'
      )
    }
  }
)

export const disconnectCharterPrepMonitorWS = createAsyncThunk<
  void,
  { memberId: string },
  { dispatch: AppDispatch }
>('ws/disconnectCharterPrepMonitor', async ({ memberId }) => {
  return await wsManager.disconnect(`charter_prep_monitor_${memberId}`)
})
